const serviceTerms = [
    { 
        id: "overview",
        title: "1. Overview", 
        content: [
            "This section provides a high-level summary of the terms governing your use of Sunspot's solar energy products and services.",
            "By accessing our website or purchasing solar solutions through Sunspot, you agree to comply with all provisions outlined in these Terms & Conditions."
        ]
    },
    { 
        id: "acceptable-use", 
        title: "2. Acceptable Use", 
        content: [
            "Our platform and services must be used responsibly and in compliance with applicable laws and regulations.",
            "Activities such as unauthorized access, fraudulent transactions, tampering with solar equipment, or engaging in unlawful activities are strictly prohibited."
        ]
    },
    { 
        id: "subscription", 
        title: "3. Orders & Payments", 
        content: [
            "All products and services are subject to availability and require confirmed orders through our platform or authorized representatives.",
            "Payments for solar panels, installation services, or maintenance plans must be made in accordance with the provided payment terms.",
            "Failure to make timely payments may result in order cancellation or service suspension."
        ]
    },
    { 
        id: "user-obligations", 
        title: "4. Customer Responsibilities", 
        content: [
            "Customers must ensure that all information provided during orders or service requests is accurate and up-to-date.",
            "Customers are responsible for granting safe and reasonable access to their property for site inspections and installations.",
            "Any unauthorized or suspicious activity on your account should be reported immediately to Sunspot support."
        ]
    },
    { 
        id: "limitation-liability", 
        title: "5. Limitation of Liability", 
        content: [
            "Sunspot shall not be held liable for indirect, incidental, or consequential damages arising from the use or inability to use our products or services.",
            "This includes delays or disruptions caused by third-party suppliers, extreme weather events, grid outages, or other factors beyond our control."
        ]
    },
    { 
        id: "termination", 
        title: "6. Termination", 
        content: [
            "We reserve the right to terminate or suspend your access to our services for violations of these Terms & Conditions.",
            "Such terminations may occur with or without prior notice, depending on the severity of the breach."
        ]
    },
    { 
        id: "intellectual-property", 
        title: "7. Intellectual Property", 
        content: [
            "All content, designs, and technology associated with the Sunspot platform are the intellectual property of Sunspot Solar Energy.",
            "Customers are granted a limited license to use the platform for the purpose of purchasing or managing solar energy solutions in accordance with these terms."
        ]
    },
    { 
        id: "governing-law", 
        title: "8. Governing Law", 
        content: [
            "These Terms & Conditions are governed by the laws of [Your Jurisdiction].",
            "Any disputes shall be resolved in the courts of [City/Region]."
        ]
    },
    { 
        id: "contact-info", 
        title: "9. Contact Information", 
        content: [
            "For any questions regarding these Terms & Conditions or our services, please contact us via:",
            "Email: support@sunspot.com",
            "Phone: +[Your Phone Number]"
        ]
    }
];

export default serviceTerms;